/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74e601b3ce776abbd8b70ea18be310cc>>
 * @codegenCommand yarn build tokens
 */

type TokenValue =
	| string;

type TokenValueOriginal =
	| string
	| {
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
		fontFamily: string;
		fontStyle: string;
		letterSpacing: string;
	};

type TokenAttributes = {
	group: string;
	state: string;
	introduced: string;
	description: string;
	suggest?: string[];
	deprecated?: string;
	replacement?: string;
};


type Token = {
	value: TokenValue;
	filePath: string;
	isSource: boolean;
	attributes: TokenAttributes;
	original: {
		value: TokenValueOriginal;
		attributes: TokenAttributes;
	};
	name: string;
	path: string[];
	cleanName: string;
};

const tokens: Token[] = [
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For overlapping brand with app promotions, such as marketplace content. Migrate instances of H900 to Heading XXL."
    },
    "value": "normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For overlapping brand with app promotions, such as marketplace content. Migrate instances of H900 to Heading XXL."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize32",
        "lineHeight": "LineHeight36",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.xxlarge",
    "path": [
      "font",
      "heading",
      "xxlarge"
    ],
    "cleanName": "font.heading.xxlarge"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For overlapping brand with app promotions, such as marketplace content. Migrate instances of H800 to Heading XL."
    },
    "value": "normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For overlapping brand with app promotions, such as marketplace content. Migrate instances of H800 to Heading XL."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize28",
        "lineHeight": "LineHeight32",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.xlarge",
    "path": [
      "font",
      "heading",
      "xlarge"
    ],
    "cleanName": "font.heading.xlarge"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "App page titles, such as forms. Migrate instances of H700 to Heading L."
    },
    "value": "normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "App page titles, such as forms. Migrate instances of H700 to Heading L."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize24",
        "lineHeight": "LineHeight28",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.large",
    "path": [
      "font",
      "heading",
      "large"
    ],
    "cleanName": "font.heading.large"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "Headers in large components, such as modal dialogs. Migrate instances of H600 to Heading M."
    },
    "value": "normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "Headers in large components, such as modal dialogs. Migrate instances of H600 to Heading M."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize20",
        "lineHeight": "LineHeight24",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.medium",
    "path": [
      "font",
      "heading",
      "medium"
    ],
    "cleanName": "font.heading.medium"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For headers in small components where space is limited. Migrate instances of H500 to Heading S."
    },
    "value": "normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For headers in small components where space is limited. Migrate instances of H500 to Heading S."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize16",
        "lineHeight": "LineHeight20",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.small",
    "path": [
      "font",
      "heading",
      "small"
    ],
    "cleanName": "font.heading.small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For headers in small components where space is limited. Migrate instances of H400 to Heading XS."
    },
    "value": "normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For headers in small components where space is limited. Migrate instances of H400 to Heading XS."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize14",
        "lineHeight": "LineHeight20",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.xsmall",
    "path": [
      "font",
      "heading",
      "xsmall"
    ],
    "cleanName": "font.heading.xsmall"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For headers in fine print or tight spaces. Use sparingly. Migrate instances of H100, H200 and H300 to Heading XXS."
    },
    "value": "normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For headers in fine print or tight spaces. Use sparingly. Migrate instances of H100, H200 and H300 to Heading XXS."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize12",
        "lineHeight": "LineHeight16",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.xxsmall",
    "path": [
      "font",
      "heading",
      "xxsmall"
    ],
    "cleanName": "font.heading.xxsmall"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For long-form text, such as in blogs."
    },
    "value": "normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For long-form text, such as in blogs."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSize16",
        "lineHeight": "LineHeight24",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.large",
    "path": [
      "font",
      "body",
      "large"
    ],
    "cleanName": "font.body.large"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "Use in short descriptions or labels. The default size for text in components. Migrate instances of Paragraph Default and UI Text to Body M."
    },
    "value": "normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "Use in short descriptions or labels. The default size for text in components. Migrate instances of Paragraph Default and UI Text to Body M."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSize14",
        "lineHeight": "LineHeight20",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.[default]",
    "path": [
      "font",
      "body",
      "[default]"
    ],
    "cleanName": "font.body"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "Use in secondary level content such as fine print or semantic messaging. Use sparingly. Migrate instances of Small text to Body S."
    },
    "value": "normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "Use in secondary level content such as fine print or semantic messaging. Use sparingly. Migrate instances of Small text to Body S."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSize12",
        "lineHeight": "LineHeight16",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.small",
    "path": [
      "font",
      "body",
      "small"
    ],
    "cleanName": "font.body.small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "5.0.1",
      "description": "Use to emphasize a number within a large donut."
    },
    "value": "normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "5.0.1",
        "description": "Use to emphasize a number within a large donut."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize28",
        "lineHeight": "LineHeight32",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.metric.large",
    "path": [
      "font",
      "metric",
      "large"
    ],
    "cleanName": "font.metric.large"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "5.0.1",
      "description": "Use to emphasize a number within a medium donut."
    },
    "value": "normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "5.0.1",
        "description": "Use to emphasize a number within a medium donut."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize24",
        "lineHeight": "LineHeight28",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.metric.medium",
    "path": [
      "font",
      "metric",
      "medium"
    ],
    "cleanName": "font.metric.medium"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "5.0.1",
      "description": "Use to emphasize a number and words in single-value tiles, or small donuts."
    },
    "value": "normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "5.0.1",
        "description": "Use to emphasize a number and words in single-value tiles, or small donuts."
      },
      "value": {
        "fontWeight": "FontWeight653",
        "fontSize": "FontSize16",
        "lineHeight": "LineHeight20",
        "fontFamily": "FontFamilyWebSansRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.metric.small",
    "path": [
      "font",
      "metric",
      "small"
    ],
    "cleanName": "font.metric.small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For representing code only, either inline or in code blocks."
    },
    "value": "normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
    "filePath": "schema/themes/atlassian-typography/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For representing code only, either inline or in code blocks."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSizeCode",
        "lineHeight": "LineHeight1",
        "fontFamily": "FontFamilyWebMonoRefreshed",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.code.[default]",
    "path": [
      "font",
      "code",
      "[default]"
    ],
    "cleanName": "font.code"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Default font weight for body text styles."
    },
    "value": "400",
    "filePath": "schema/themes/atlassian-typography/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Default font weight for body text styles."
      },
      "value": "FontWeight400"
    },
    "name": "font.weight.regular",
    "path": [
      "font",
      "weight",
      "regular"
    ],
    "cleanName": "font.weight.regular"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "For all text that may appear beside iconography, such as in a button."
    },
    "value": "500",
    "filePath": "schema/themes/atlassian-typography/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "For all text that may appear beside iconography, such as in a button."
      },
      "value": "FontWeight500"
    },
    "name": "font.weight.medium",
    "path": [
      "font",
      "weight",
      "medium"
    ],
    "cleanName": "font.weight.medium"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Use with caution as fallback fonts do not support this font weight and will default to bold weight."
    },
    "value": "600",
    "filePath": "schema/themes/atlassian-typography/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Use with caution as fallback fonts do not support this font weight and will default to bold weight."
      },
      "value": "FontWeight600"
    },
    "name": "font.weight.semibold",
    "path": [
      "font",
      "weight",
      "semibold"
    ],
    "cleanName": "font.weight.semibold"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Use sparingly for emphasising text, such as in a lozenge."
    },
    "value": "653",
    "filePath": "schema/themes/atlassian-typography/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Use sparingly for emphasising text, such as in a lozenge."
      },
      "value": "FontWeight653"
    },
    "name": "font.weight.bold",
    "path": [
      "font",
      "weight",
      "bold"
    ],
    "cleanName": "font.weight.bold"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For our default UI heading text."
    },
    "value": "\"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For our default UI heading text."
      },
      "value": "FontFamilyWebSansRefreshed"
    },
    "name": "font.family.heading",
    "path": [
      "font",
      "family",
      "heading"
    ],
    "cleanName": "font.family.heading"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For our default UI body text."
    },
    "value": "\"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For our default UI body text."
      },
      "value": "FontFamilyWebSansRefreshed"
    },
    "name": "font.family.body",
    "path": [
      "font",
      "family",
      "body"
    ],
    "cleanName": "font.family.body"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For representing code only."
    },
    "value": "\"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
    "filePath": "schema/themes/atlassian-typography/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For representing code only."
      },
      "value": "FontFamilyWebMonoRefreshed"
    },
    "name": "font.family.code",
    "path": [
      "font",
      "family",
      "code"
    ],
    "cleanName": "font.family.code"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For our brand heading text. Uses Charlie Display."
    },
    "value": "\"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For our brand heading text. Uses Charlie Display."
      },
      "value": "FontFamilyCharlieDisplay"
    },
    "name": "font.family.brand.heading",
    "path": [
      "font",
      "family",
      "brand",
      "heading"
    ],
    "cleanName": "font.family.brand.heading"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "For our brand body text. Uses Charlie Text."
    },
    "value": "\"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "For our brand body text. Uses Charlie Text."
      },
      "value": "FontFamilyCharlieText"
    },
    "name": "font.family.brand.body",
    "path": [
      "font",
      "family",
      "brand",
      "body"
    ],
    "cleanName": "font.family.brand.body"
  }
];

export default tokens;
